export const PURCHASE_EXCEL_UPLOAD_COULUMNS = [
  {
    Header: 'L1 Approver Date',
    key: 'approver1_date'
  },
  {
    Header: 'Voucher Type Name',
    key: 'voucher_type'
  },
  {
    Header: 'Voucher Number',
    key: 'entry_code'
  },
  {
    Header: 'Ledger Name',
    key: 'ledger_name'
  },
  {
    Header: 'Ledger Amount',
    key: 'ledger_amount'
  },
  {
    Header: 'Ledger Amount Dr/Cr',
    key: 'ledgerAmountDrCr'
  },
  {
    Header: 'Cost Allocation for - Cost Centre',
    key: 'cost_center'
  },
  {
    Header: 'Cost Allocation for - Amount',
    key: 'cost_center_amount'
  },
  {
    Header: 'Bill Type of Ref',
    key: 'billTypeRef'
  },
  {
    Header: 'Bill Name',
    key: 'invoice_no'
  },
  {
    Header: 'Bill Amount',
    key: 'ledger_amount'
  },
  {
    Header: 'Bill Amount - Dr/Cr',
    key: 'ledgerAmountDrCr'
  },
  {
    Header: 'Reference No.',
    key: 'invoice_no'
  },
  {
    Header: 'Reference Date',
    key: 'accounting_date'
  },
  {
    Header: 'Voucher Narration',
    key: 'narration'
  },
  {
    Header: 'PR Index',
    key: 'payment_request_id'
  },
  {
    Header: 'Ledger_Name_Key',
    key: 'ledger_name_key'
  },
  {
    Header: 'Ledger_Type',
    key: 'ledger_type'
  },
  {
    Header: 'ZAPS_Ledger_Name',
    key: 'zaps_ledger_name'
  },
  {
    Header: 'ZAPS_GST_Slab',
    key: 'zaps_gst_slab'
  },
  {
    Header: 'Bill Link',
    key: 'bill_link'
  },
  {
    Header: 'Supporting Document Link',
    key: 'supporting_document_link'
  },
  {
    Header: 'EXP_FTM',
    key: 'exp_ftm'
  },
  {
    Header: 'City',
    key: 'city'
  },
  {
    Header: 'Setup Flag',
    key: 'setup_flag'
  },
  {
    Header: 'Transaction_Date',
    key: 'transaction_date'
  },
  {
    Header: 'Transaction_ID',
    key: 'transaction_id'
  },
  {
    Header: 'Settlement_Type',
    key: 'settlement_type'
  },
  {
    Header: 'GST Availment Type',
    key: 'gst_avail_type'
  },
  {
    Header: 'PO_No.',
    key: 'po_no'
  },
  {
    Header: 'Payment_Request_Date',
    key: 'payment_request_date'
  },
  {
    Header: 'GST_Map_ID',
    key: 'gst_map_id'
  },
  {
    Header: 'ZAPS_Entity_Type',
    key: 'zaps_entity_type'
  },
  {
    Header: 'Vendor Name',
    key: 'vendor_name'
  }
]



// WEBPACK FOOTER //
// ./src/constants/tableColumns.js